<template>
  <div>
    <div class="bg-white shadow-lg rounded-sm border border-slate-200 relative mb-8">
      <header class="flex flex-col gap-y-5 p-5">
        <form class="relative" @submit.prevent>
          <span class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
            <img src="@/assets/search.svg" class="w-4 h-4 shrink-0 text-slate-400" alt="" />
          </span>
          <input
            class="form-input pl-9 bg-white w-full"
            type="search"
            placeholder="Search for a service"
            v-model="searchQuery"
          />
        </form>
      </header>
    </div>

    <div v-if="filteredServices.length" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      <div
        v-for="service in filteredServices"
        :key="service.id"
        class="service-card bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 ease-in-out flex flex-col"
      >
        <p class="text-xs uppercase tracking-wide text-indigo-600 font-medium mb-1">
          {{ service.category }}
        </p>
        <h2 class="service-title text-lg font-semibold text-gray-800 mb-2">{{ service.name }}</h2>
        <p class="service-description text-gray-600 text-sm leading-relaxed mb-4 flex-1">
          {{ service.description }}
        </p>
        <div class="flex items-center justify-between gap-3 mt-auto">
          <span v-if="countFor(service.id)" class="text-xs text-slate-500">
            {{ countFor(service.id) }} in estimate
          </span>
          <span v-else></span>
          <SecondaryButton
            @click="navigateToConfig(service.id)"
            :text="'Configure'"
            class="px-4 py-2 text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition duration-150 ease-in-out"
          />
        </div>
      </div>
    </div>
    <div v-else class="text-center py-10 text-gray-500 text-lg">
      No services found matching your search.
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { services } from "@/utils/services.js";
import SecondaryButton from "@/components/SecondaryButton.vue";

export default {
  components: {
    SecondaryButton,
  },
  data() {
    return {
      services,
      searchQuery: "",
    };
  },
  computed: {
    ...mapGetters({ addedServices: "services/addedServices" }),

    filteredServices() {
      const term = this.searchQuery.trim().toLowerCase();
      if (!term) return this.services;

      // Search the description and keywords too, so "postgres" or "waf" find
      // the section that actually offers them.
      return this.services.filter((service) =>
        [service.name, service.category, service.description, ...(service.keywords || [])]
          .join(" ")
          .toLowerCase()
          .includes(term)
      );
    },
  },
  methods: {
    countFor(serviceId) {
      return this.addedServices.filter((line) => line.serviceId === serviceId).length;
    },
    navigateToConfig(serviceId) {
      if (!serviceId) return;
      this.$router.push(`/config/services/${serviceId}`);
    },
  },
};
</script>

<style lang="postcss" scoped>
.service-card {
  @apply p-5;
}

.form-input {
  @apply pl-9;
}
</style>
